module.exports = __webpack_public_path__ + "media/assets/dropdown2-18de95efd272210ba867a667160837c3d9e18d8f24e19d8ea34abf1a463b8598.png";